import { Panel } from "@poseidon/ui/components/Panel";
import { Button, Grid } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Field } from "formik";
import { Checkbox } from "formik-mui";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import React from "react";
import EditApplicationFormWrapper from "./EditApplicationFormWrapper";

export function ApplicationLocksPanel({ application }) {
  const initialValues = {
    id: application.id,
    lock_personalDetails: application.lock_personalDetails ?? false,
    lock_sailor: application.lock_sailor ?? false,
    lock_dealer: application.lock_dealer ?? false,
  };
  return (
    <EditApplicationFormWrapper
      initialValues={initialValues}
      application={application}
    >
      {({ isSubmitting, dirty }) => (
        <Panel
          expandable
          title="Locks"
          actions={
            <Button
              size="small"
              type="submit"
              disabled={!dirty || isSubmitting}
            >
              Save
            </Button>
          }
        >
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Field
                    component={Checkbox}
                    icon={<LockOpenIcon />}
                    checkedIcon={<LockIcon />}
                    type="checkbox"
                    name="lock_personalDetails"
                    margin="none"
                  />
                }
                label="Personal Details (Approving credit)"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Field
                    component={Checkbox}
                    icon={<LockOpenIcon />}
                    checkedIcon={<LockIcon />}
                    type="checkbox"
                    name="lock_sailor"
                    margin="none"
                  />
                }
                label="Full Sailor Lock"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Field
                    component={Checkbox}
                    icon={<LockOpenIcon />}
                    checkedIcon={<LockIcon />}
                    type="checkbox"
                    name="lock_dealer"
                    margin="none"
                  />
                }
                label="Full Dealer Lock"
              />
            </Grid>
          </Grid>
        </Panel>
      )}
    </EditApplicationFormWrapper>
  );
}
